module.exports = __webpack_public_path__ + "5c6971f2fb70457f999d27be41c213c7.svg";